// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1pmkD","list":"styles_list__1JG_v"};